<template>
  <div class="pay">
       <Step class="step" :active="active_index" ></Step>
        <div class="title">请核对订单信息并完成支付</div>
        <PurchaseTitle titlename="购券信息" subname="编辑" :sublink="'../purchasecoupon/purchase?orderId='+orderId+'&sourcetype=edit'"></PurchaseTitle>
        <CouponDetail :couponInfo="couponDetail"></CouponDetail>
        <PurchaseTitle class="payinfo" titlename="支付"></PurchaseTitle>
        <div class="info-wrap">
            <div class="item">
                <label>支付总金额</label>
                <span class="msg">{{ hasInfo ? couponDetail.orderInfo.totalAmount : '' }}元
                    <span class="detailmsg">（包含发券总金额{{ hasInfo ? couponDetail.orderInfo.totalCouponAmount : '' }}元，制券费{{ hasInfo ? couponDetail.orderInfo.serviceAmount : '' }}元{{ couponDetail.discountAmount > 0 ? `，减去折扣优惠金额${couponDetail.discountAmount}元）`:'）' }}</span>
                </span>
            </div>
            <div class="item">
                <label>余额抵扣</label>
                <span class="msg">{{ hasInfo ? couponDetail.balanceDeductionAmount : '' }}元</span>
            </div>
            <div class="item" v-if="!isOldGroup">
                <label>还需支付</label>
                <span class="msg">{{ hasInfo ? couponDetail.needPayAmount : '' }}元</span>
            </div>
        </div>
        <div class="dopay "
            v-bind:class="{ notshow: hasInfo ? !Number(couponDetail.needPayAmount) : false}"
        >
            <p v-if="isOldGroup" class="oldGroupTips">
              滴滴出行券平台服务主体现已由“滴滴出行科技有限公司”变更为“北京桔财动力科技有限公司”。变更前的充值、开票、余额，您可至原先工作台进行查看并使用，或进行退款操作，原工作台的充值余额，继续开具“滴滴出行”发票。即日起充值或开票，均由“桔财动力”提供服务，您可至对应的“桔财动力”后缀的后台进行查看并使用。
            </p>
            <div class="item" v-else>
                <label>选择支付方式</label>
                <!-- <div class="paymsg" @click="choosePayType(0)"
                 v-bind:class="{ paychoosed: !payType}"
                >
                    <span class="weixin_icon"></span>
                微信支付
                    <span v-if="!payType" class="chooseicon"></span>
                </div> -->
                <div class="paymsg" @click="choosePayType(1)"
                v-bind:class="{ paychoosed: payType}"
                >
                    <span class="ali_icon"></span>
                支付宝
                    <span  v-if="payType" class="chooseicon"></span>
                </div>
            </div>
        </div>
    <div class="bot">
        <el-button type="primary" :disabled="isPayBtnDisable || oldGroupBtnDisable" @click="goPay">确认支付</el-button>
        <span v-if="oldGroupBtnDisable" class="disableTips">当前工作台余额不足，不可购券</span>
    </div>
    <PayModal v-if="showModal"
        :showModal="showModal"
        :payType="payType"
        :type="1"
        :orderId="orderId"
        :amount="couponDetail.needPayAmount"
        @close="closePayModal"
    ></PayModal>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import Step from './components/step.vue'
import PurchaseTitle from './components/title.vue'
import CouponDetail from './components/CouponDetail.vue'
import PayModal from 'Components/PayModal.vue'

export default {
  name: 'pay',
  data () {
    return {
      active_index: 1,
      couponDetail: {
        // balanceDeductionAmount: 0,
        // orderInfo: {
        //   totalAmount: 0
        // }
      },
      hasInfo: false,
      payType: 1, // 0维信，1支付宝
      showModal: false,
      // payLink: {},
      id: '', // 支付轮询id
      orderId: this.$route.query.orderId || '',
      // purchaseDisabled: false
    }
  },
  components: {Step, PurchaseTitle, CouponDetail, PayModal},
  created () {
    this.getPayOrderInfo({orderId: this.orderId})
  },
  computed: {
    isOldGroup:function(){
      return this.$store.state.header.selfGroup.version == 0 ? true :false
    },
    oldGroupBtnDisable:function(){
      let isdisable = false ;
      console.log('this.CouponDetail.balanceDeductionAmount',this.hasInfo)
      if(this.$store.state.header.selfGroup.version == 0 && this.hasInfo){
         if(this.couponDetail.balanceDeductionAmount < this.couponDetail.needPayAmount){
           isdisable = true;
         }
      }
      return isdisable
    },
    ...mapState('couponPay', ['couponInfo', 'enoughPayInfo','isPayBtnDisable'])
    // ...mapGetters('header',['selfGroup'])
  },
  methods: {
    ...mapActions('couponPay', ['getPayOrderInfo', 'enoughPay']),
    ...mapActions('couponPay', ['stopPolling']),
    // ...mapMutations('header', ['SET_GROUP']),
    choosePayType (type) { // 选择支付方式
      this.payType = type
    },
    goPay () { // 确认支付按钮
      // 如果余额不足
      if (Number(this.couponDetail.needPayAmount) > 0) {
        this.showModal = true
      } else { // 充足直接支付
        console.log('enoughPay')
        this.enoughPay({orderId: this.orderId})
      }
      this.omgTrack('es_chuxingquan_xieyi_topay_ck', '出行券模块点击确认支付')
    },
    closePayModal () {
      this.showModal = false
      this.stopPolling()
    },
  },
  watch: {
    couponInfo: function (value) {
      if (value) {
        this.couponDetail = value
        this.hasInfo = true
      }
    },
    enoughPayInfo: function (data) {
      // 这里有可能有问题
      if (data) {
        this.$router.push({path: 'paynext', query: {orderId: this.orderId, status: data}}).catch(err => {})
        if (Number(data) === 3 || Number(data) === 4) {
          this.omgTrack('es_chuxingquan_xieyi_paid_exp', '出行券模块支付成功')
        }
      }
    }
  }
}
</script>
<style  scoped  lang="stylus">
  .disableTips{
    color: #f00;
    margin-left: 20px;
    font-size: 14px;
  }
    .pay{
        padding-left:20px;
        .step{
            margin-left:20px;
        }
        .title{
            color: #333;
            font-size: 18px;
            margin-bottom: 30px;
            margin-left: 20px;
        }
        .payinfo{
            margin-top: 40px;
        }
        .info-wrap{
            padding-left: 30px;
            margin-bottom 50px;
        }
        .item{
            position: relative;
            margin-top: 28px;
            margin-left: 27px;
            label{
                width: 84px;
                display: inline-block;
                text-align: right;
                font-size:14px;
                color: #666;
                margin-right: 20px;
            }
            .msg{
                color: #333;
                font-size: 14px;
                .detailmsg{
                    font-size: 12px;
                    color: #999;
                }
            }
        }
        .dopay{
            border-top: solid 1px #E5E5E5;
            margin-left: 30px;
            margin-top:40px;
            padding-top:10px;
            padding-bottom: 100px;
            label{
                position: relative;
                top: -23px;
            }
            .paymsg{
                position: relative;
                display: inline-block;
                width: 160px;
                height: 70px;
                margin-right: 20px;
                border: 1px solid #E0E0E0;
                line-height: 70px;
                text-align: center;
                font-size:18px;
                color:#333;
            }
            .weixin_icon{
                width: 24px;
                height: 24px;
                background: url('../../images/pay_weipay.png');
                background-size: 100% auto;
                display: inline-block;
                position: relative;
                top: 5px;
            }
            .ali_icon{
                width: 24px;
                height: 24px;
                background: url('../../images/pay_alipay.png');
                background-size: 100% auto;
                display: inline-block;
                position: relative;
                top: 5px;
            }
            .paychoosed{
                border: 1px solid #3468FF;
            }
            .chooseicon{
                width: 30px;
                height: 30px;
                background: url('../../images/check.png');
                background-size: 100% auto;
                display: inline-block;
                position: absolute;
                left: 131px;
                top: 40px;
            }
        }
        .oldGroupTips{
          
           
              font-size: 14px;
              line-height: 24px;
              width: 500px;
              padding: 40px 40px 0 40px;
              text-indent: 2em;
        }
        .notshow{
            display:none
        }
        .bot{
            padding-top: 16px;
            background-color: #fff;
            z-index: 9999999;
            padding-left: 191px;
            box-shadow: 0 -5px 15px 0 hsla(0,1%,65%,.15);
            position: fixed;
            bottom: 0;
            width: 100%;
            height: 64px;
            margin-left:-30px;
        }
    }
</style>
